// Import from centralized toast utility
export { DEFAULT_TOAST_OPTIONS } from 'utils/toast';

export const SIGN_UP = 'Sign Up';
export const LOGOUT = 'Sign Out';
export const LOGIN = 'Sign In';
export const FORGOT_PASSWORD = 'Forgot Password?';
export const PASSWORD = 'Password';
export const YOUR_EMAIL = 'Your email';

export const UPCOMING_GAMES_LABEL = 'Upcoming Events';
export const TODAYS_GAMES_LABEL = "Today's Events";
export const LIVE_EVENTS_LABEL = 'Live Events';

export const UPCOMING_GAMES_ITEM = {
  label: UPCOMING_GAMES_LABEL,
  value: 'ug-1',
};

export const TODAYS_GAMES_ITEM = {
  label: TODAYS_GAMES_LABEL,
  value: 'td-1',
};

export const LIVE_EVENTS_ITEM = {
  label: LIVE_EVENTS_LABEL,
  value: 'le-1',
};
